import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import {
    PaginateResponse,
    PreventiveMaintenance,
    PlanDateRequest,
    Response,
    Wrsv,
    Apr,
    CM,
} from '../model';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { Adhoc } from 'app/modules/well-integrity-planning/model/adhoc.model';
import { OtherActivity } from 'app/modules/well-integrity-planning/model/other.model';

@Injectable({ providedIn: 'root' })
export class WipService {
    constructor(private _httpClient: HttpClient) { }

    getPreventiveTable(
        params: any
    ): Observable<Response<PaginateResponse<PreventiveMaintenance>>> {
        const url = composeUrl(
            `/v1/PreventiveMaintenance/Pm/GetPmRegisterList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<PreventiveMaintenance>>>(url)
            .pipe(take(1));
    }

    getWrsv(params: any): Observable<Response<PaginateResponse<Wrsv>>> {
        const url = composeUrl(
            `/v1/WellActivityPlanning/GetWrsvPlanningList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<Wrsv>>>(url)
            .pipe(take(1));
    }

    getAdhoc(params: any): Observable<Response<PaginateResponse<Adhoc>>> {
        const url = composeUrl(
            `/v1/WellActivityPlanning/AdhocActivityPlanningList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<Adhoc>>>(url)
            .pipe(take(1));
    }

    getOtherActivity(params: any): Observable<Response<PaginateResponse<OtherActivity>>> {
        const url = composeUrl(
            `/v1/WellActivityPlanning/OtherActivityList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<OtherActivity>>>(url)
            .pipe(take(1));
    }

    getApr(params: any): Observable<Response<PaginateResponse<Apr>>> {
        const url = composeUrl(
            `/v1/WellActivityPlanning/GetAprPlanningList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<Apr>>>(url)
            .pipe(take(1));
    }

    getCM(params: any): Observable<Response<PaginateResponse<CM>>> {
        const url = composeUrl(
            `/v1/WellActivityPlanning/GetCmPlanningList`,
            params
        );
        return this._httpClient
            .get<Response<PaginateResponse<CM>>>(url)
            .pipe(take(1));
    }

    updatePreventive(payload: PlanDateRequest): Observable<any> {
        const url = composeUrl(`/v1/PreventiveMaintenance/Pm/UpdatePmRegister`);
        return this._httpClient.post<any>(url, payload);
    }

    updateWrsv(payload: PlanDateRequest): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/UpdateWrsvPlanning`);
        return this._httpClient.put<any>(url, payload);
    }

    updateApr(payload: PlanDateRequest): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/UpdateAprPlanning`);
        return this._httpClient.put<any>(url, payload);
    }

    updateCm(payload: PlanDateRequest): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/UpdateCmPlanning`);
        return this._httpClient.put<any>(url, payload);
    }

    updateAdhoc(payload: PlanDateRequest): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/AdhocActivityPlanning`);
        return this._httpClient.put<any>(url, payload);
    }

    createAdhoc(payload: PlanDateRequest): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/AdhocActivityPlanning`);
        return this._httpClient.post<any>(url, payload);
    }

    deleteAdhocActivity(id: string): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/AdhocActivityPlanning/${id}`);
        return this._httpClient.delete<any>(url);
    }

    createOtherActivity(payload: OtherActivity): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/OtherActivity`);
        return this._httpClient.post<any>(url, payload);
    }

    updateOtherActivity(payload: OtherActivity): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/OtherActivity`);
        return this._httpClient.put<any>(url, payload);
    }

    deleteOtherActivity(id: string): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/OtherActivity/${id}`);
        return this._httpClient.delete<any>(url);
    }

    getWellString(search: any = {}) {
        search.hasProductionStatus = true;
        const url = composeUrl('/v1/WellHeaderInformation/FilterData', search);
        return this._httpClient.get<Response<PaginateResponse<any>>>(url);
    }

    downloadExcel(endpoint: string, type: string) {
        const url = composeUrl(`${endpoint}`);
        this._httpClient
            .get(url, { responseType: 'blob' })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `WIP-${type}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    }

    CreateUpdateRemarks(payload: any): Observable<any> {
        const url = composeUrl(`/v1/WellActivityPlanning/CreateUpdateWipRemark`);
        return this._httpClient.post<any>(url, payload);
    }
}
